"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilesTabFileUploadModal = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var Types = require("types");
var fileUploadModal_1 = require("actions/fileUploadModal");
var GenericFileUploadModal_1 = require("../GenericFileUploadModal");
var Container_1 = require("../GenericFileUploadModal/Container");
var FileList_1 = require("./FileList");
var Progress_1 = require("./Progress");
var Buttons_1 = require("./Buttons");
var mapStateToProps = function (state) {
    return {
        fileUploadModalDescription: state.fileUploadModal.modalState.description,
        fileUploadModalStatus: state.fileUploadModal.modalState.isOpen,
        currentProject: state.project.currentProject,
        uploadSession: state.fileUploadModal.currentUploadStatus.session
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    cancelUpload: function (session) { return function () { return (dispatch(fileUploadModal_1.default.toggleModalStatus()),
        dispatch(fileUploadModal_1.default.fileUploadCancelAction(session))); }; }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    shouldComponentUpdate: function (nextProps) {
        if (this.props.fileUploadModalStatus !== nextProps.fileUploadModalStatus ||
            this.props.currentProject !== nextProps.currentProject ||
            this.props.uploadSession !== nextProps.uploadSession) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
exports.FilesTabFileUploadModal = enhance(function (props) { return (React.createElement(GenericFileUploadModal_1.default, { isOpen: props.fileUploadModalStatus, onRequestClose: props.cancelUpload(props.uploadSession) },
    React.createElement(Container_1.Container, null,
        props.fileUploadModalDescription && (React.createElement("div", { className: "description" },
            React.createElement("span", null, props.fileUploadModalDescription),
            ' ',
            React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/files/genericFileUploadModal/descriptionText/youCanselectDescriptionFileUploadModal')))),
        React.createElement(FileList_1.default, null),
        React.createElement(Progress_1.default, null)),
    React.createElement(Buttons_1.default, { cancelUpload: props.cancelUpload(props.uploadSession) }))); });
